<style lang="scss">
  @use "../../../assets/css/design-system/colors";
  @use "../../../assets/css/design-system/mixins";
  @use "../../../assets/css/design-system/utils";

  .system-banner-notification {
    display: flex;
    gap: utils.in_rem(12px);
    align-items: center;
    justify-content: flex-start;
    width: 100%;
    padding: utils.in_rem(12px) utils.in_rem(24px);

    &.sw-ds-success {
      color: colors.get(systemPositive_100);
      background-color: colors.get(systemPositive_10);
    }
    &.sw-ds-error {
      color: colors.get(systemError_100);
      background-color: colors.get(systemError_10);
    }
    &.sw-ds-warning {
      color: colors.get(systemWarning_100);
      background-color: colors.get(systemWarning_10);
    }
    &.sw-ds-information {
      background-color: colors.get(primary_5);
    }
  }
</style>

<script>
  import { fade } from "svelte/transition";
  import SystemBannerIcon from "./SystemBannerIcon.svelte";
  import { onMount } from "svelte";

  let { kind, style = "", leadingIcon = "", children } = $props();
  let display = $state(false);

  onMount(() => {
    display = true;
  });
</script>

{#if display}
  <div transition:fade class="system-banner-notification sw-ds-{kind}" {style}>
    {#if typeof leadingIcon === "function"}
      {@render leadingIcon()}
    {:else if leadingIcon}
      <SystemBannerIcon {kind} {leadingIcon} />
    {/if}
    {@render children?.()}
  </div>
{/if}
